import React from 'react';
import PropTypes from 'prop-types';
import { Record } from 'immutable';
import moment from 'moment';
import * as localise from '../../../../utils/localise';
import { bonusBetFlag, thirdPartyFlag, rule4DeductionFlag } from '../../BetReportIcons/BetReportIcons';
import IconLiveBetting from '../../../../../images/thirdPartyBet/icon-livebetting.svg';
import './Bet.scss';

const BASE = 'mb-reportSettledBet';

const inPlayFlag = (<span
  aria-label="Bet was matched while event was in-play."
  className="hint hint--top"
>
  <IconLiveBetting />
</span>);

const SettledBet = ({ bet, currency, oddsType }) => {
  const netPnl = bet.profitAndLoss - (bet.commission || 0);

  const pnlClass = netPnl > 0.01 ? `${BASE}__netPnl--positive` : '';

  let profitAndLossValue = localise.currency(bet.profitAndLoss, currency);

  if (netPnl === bet.profitAndLoss) {
    profitAndLossValue = '-.--';
  }

  return (<tr className={BASE}>
    <td />
    <td />
    <td className={`${BASE}__matchedTimeCell`}>
      <div className={`${BASE}__matchedTime`}>
        <span>
          {moment(bet.matchedTime).format('DD MMM YYYY HH:mm')}
        </span>
        <span className={`${BASE}__betId`}>
          {bet.id}
        </span>
      </div>
      <div className={`${BASE}__thirdPartyLogo`}>
        {bet.inPlay ? inPlayFlag : null}
        {bet.useBonus ? bonusBetFlag : null}
        {bet.thirdPartyClientId ? thirdPartyFlag : null}
        {bet.adjusted ? rule4DeductionFlag : null}
      </div>
    </td>
    <td className={`${BASE}__odds`}>
      {localise.odds(bet.odds, { oddsType, side: bet.side.toLowerCase() })}
      {
        /*
        // Hide originator flag on Settled Bets
        // This is a temporary solution until the originator flag is available for Current Bets
        bet.originator
          ? <div className={`${BASE}__originatorIcon`}>
            <IconStar />
          </div>
          : null
        */
      }
    </td>
    <td className={`${BASE}__stakes`}>
      <span className={`${BASE}__stake ${pnlClass}`}>
        {localise.currency(bet.stake, currency)}
      </span>
      <span className={`${BASE}__liability`}>
        {/* TODO: Restore liability figure when API returns it */}
        {/* localise.currency(bet.exposure, currency) */}
      </span>
    </td>
    <td className={`${BASE}__pnl`}>
      <span className={`${BASE}__netPnl ${pnlClass}`}>
        {localise.currency((netPnl), currency)}
      </span>
      <span className={`${BASE}__grossPnl`}>
        {profitAndLossValue}
      </span>
    </td>
    <td className={`${BASE}__commission`}>
      <span className={`${BASE}__commAmount`}>
        {
          bet.commission !== null
            ? localise.currency(bet.commission, currency)
            : '-.--'
        }
      </span>
      <span className={`${BASE}__commType`}>
        {bet.commissionRate !== null ? `${bet.commissionRate}%` : ''}
      </span></td>
  </tr>);
};

SettledBet.propTypes = {
  currency: PropTypes.string,
  oddsType: PropTypes.string,
  bet: PropTypes.instanceOf(Record).isRequired,
};

export default SettledBet;
